<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white dataPage" v-if="$currentUser.role !== 'account'">
            <div class="page-header">
                <h3 class="page-title">Данные</h3>
            </div>
            <div class="row">
                <div class="col lg-12">
                    <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
                        <span>{{alertText}}</span>
                    </b-alert>
                    <b-alert v-model="showSuccessAlert" variant="success" dismissible>
                      <span>{{successAlertText}}</span>
                    </b-alert>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" v-if="isMobile">
                    <b-btn size="sm" variant="success" class="mainButton filterComponent" style="white-space: nowrap;"
                           v-b-modal.createData>
                        Добавить данные
                        <i class="icon-fa icon-fa-pencil"></i>
                    </b-btn>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" v-if="!isMobile">
                    <b-btn size="sm" variant="success" class="mainButton filterComponent" style="white-space: nowrap;"
                           @click="addTable">
                        Добавить данные
                        <i class="icon-fa icon-fa-pencil"></i>
                    </b-btn>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2" v-if="!isMobile">
                    <b-button-group class="filterComponent" style="width: 100%!important;">
                        <b-button variant="success" class="mr-1" v-on:click="selectAllRows"
                                  size="sm">
                            <i class="icon-fa icon-fa-check-square-o"></i>
                        </b-button>
                        <b-button variant="danger" class="mr-1" v-on:click="unselectAllRows"
                                  size="sm">
                            <i class="icon-fa icon-fa-close"></i>
                        </b-button>
                        <b-button variant="primary" class="mr-1" v-on:click="changeLeadRate"
                                  size="sm">
                            <i class="icon-fa icon-fa-edit"></i>
                        </b-button>
                        <b-button variant="warning" class="mr-1" v-on:click="copySelected()" size="sm">
                            <i class="icon-fa icon-fa-copy"></i>
                        </b-button>
                        <b-button v-if="$currentUser.role === 'admin'" variant="info" v-on:click="openDataUploadModal" size="sm">
                          <i class="icon-fa icon-fa-upload"></i>
                        </b-button>
                    </b-button-group>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-button-group :key="dateRange" v-if="isXl" class="filterComponent datePickerXl">
                        <date-range-picker
                                ref="picker"
                                :locale-data="dateRangeLocalFormat"
                                v-model="range"
                                :opens="'center'"
                                :ranges="dateRanges"
                                @update="selectRange($event)">
                            <template v-slot:input="picker" style="min-width: 350px;!important;">
                                {{ range.startDate | formatDateRange }} - {{ range.endDate | formatDateRange  }}
                            </template>
                            <div slot="header" slot-scope="header" class="slot">
                                <h2>Выбрать даты создания данных</h2>
                            </div>
                        </date-range-picker>
                        <b-button size="sm" variant="primary">
                            <i class="icon-fa icon-fa-calendar-check-o"></i>
                        </b-button>
                    </b-button-group>
                    <b-input-group :key="dateRange" v-if="!isXl" class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <datepicker input-class="form-control dateFromCreated"
                                        class="date dateLeft"
                                        style="color: blue;"
                                        monday-first
                                        size="sm"
                                        @selected="selectStartRange($event)"
                                        v-model="range.startDate"
                                        :language="ru"
                                        placeholder="С:">
                            </datepicker>
                            <datepicker input-class="form-control dateToCreated"
                                        class="date dateRight"
                                        style="color: blue;"
                                        monday-first
                                        size="sm"
                                        @selected="selectEndRange($event)"
                                        v-model="range.endDate"
                                        :language="ru"
                                        placeholder="По:">
                            </datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2">
                    <b-button-group :key="dateRange" v-if="isXl" class="filterComponent datePickerXl">
                        <date-range-picker
                                ref="picker"
                                :locale-data="dateRangeLocalFormat"
                                v-model="secondDateRange"
                                :opens="'center'"
                                :ranges="dateRanges"
                                @update="selectSecondRange($event)">
                            <template v-slot:input="picker" style="min-width: 350px;!important;">
                                {{ secondDateRange.startDate | formatDateRange }} - {{ secondDateRange.endDate | formatDateRange  }}
                            </template>
                            <div slot="header" slot-scope="header" class="slot">
                                <h2>Выбрать даты внесения данных</h2>
                            </div>
                        </date-range-picker>
                        <b-button size="sm" variant="success">
                            <i class="icon-fa icon-fa-calendar-check-o"></i>
                        </b-button>
                    </b-button-group>
                    <b-input-group :key="dateRange" v-if="!isXl" class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <datepicker input-class="form-control dateFrom"
                                        class="date dateLeft"
                                        size="sm"
                                        monday-first
                                        style="color: green;"
                                        @selected="selectSecondStartRange($event)"
                                        v-model="secondDateRange.startDate"
                                        :language="ru"
                                        placeholder="С:">
                            </datepicker>
                            <datepicker input-class="form-control dateTo"
                                        class="date dateRight"
                                        style="color: green;"
                                        size="sm"
                                        monday-first
                                        @selected="selectSecondEndRange($event)"
                                        v-model="secondDateRange.endDate"
                                        :language="ru"
                                        placeholder="По:">
                            </datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>

                <div class="col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2">
                    <b-button variant="outline-success" size="sm"
                              class="mb-2 mainButton"
                              :class="showCollapse2 ? 'collapsed' : null"
                              :aria-expanded="showCollapse2 ? 'true' : 'false'"
                              aria-controls="collapse-3"
                              @click="onClick()">
                        Фильтры
                        <span v-if="showCollapse2"><i class="icon-fa icon-fa-minus"></i></span>
                        <span v-if="!showCollapse2"><i class="icon-fa icon-fa-plus"></i></span>
                    </b-button>
                </div>


                <div class="col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton">
                    <b-input-group class="filterComponent">
                        <div></div>
                        <b-input-group-append>
                            <b-btn size="sm" text="Search" variant="success"
                                   class="mainButton filterComponent"
                                   style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                                   @click="getData(1, null)">
                                Применить
                                <!--<i class="icon-fa icon-fa-search"></i>-->
                            </b-btn>
                            <b-btn size="sm" variant="outline-danger" class="mainButton filterComponent"
                                   @click="resetFilters">Очистить
                                <!--<i class="icon-fa icon-fa-times"></i>-->
                            </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>


            <b-collapse id="collapse-2" v-model="showCollapse2" class="mt-2">
                <b-card>
                    <div class="row mb-2">
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2"
                             v-if="$currentUser.role == 'admin' || $currentUser.role == 'leader'">
                            <v-select label="name" :options="users" required v-model="user" placeholder="Медиабайер"
                                      multiple>
                                <span slot="no-options">Совпадений не найдено.</span>
                            </v-select>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <v-select :options="selectOffers" :filter="filterOffers" required label="title"
                                      v-model="search"
                                      placeholder="Оффер"
                                      multiple>
                                <span slot="no-options">Совпадений не найдено.</span>
                                <template slot="option" slot-scope="option">
                                    <span>({{option.id}}) {{ option.title }}</span>
                                </template>
                            </v-select>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <v-select :options="sources" :filter="filterSources" required label="title"
                                      v-model="source"
                                      placeholder="Источник"
                                      multiple>
                                <span slot="no-options">Совпадений не найдено.</span>
                                <template slot="option" slot-scope="option">
                                    <span>({{option.id}}) {{ option.title }}</span>
                                </template>
                            </v-select>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <v-select :options="types"
                                      placeholder="Тип"
                                      :clearable="false"
                                      :searchable="false"
                                      v-model="type">
                            </v-select>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <v-select :options="isTestOptions"
                                      :searchable="false"
                                      :clearable="false"
                                      v-model="isTest"
                                      placeholder="Тест">
                            </v-select>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <b-form-input class="insertInput"
                                          type="text"
                                          style="height: 35px;"
                                          placeholder="Subid-1"
                                          v-model="selectedSub1">
                            </b-form-input>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <b-form-input class="insertInput"
                                          type="text"
                                          style="height: 35px;"
                                          placeholder="Subid-2"
                                          v-model="selectedSub2">
                            </b-form-input>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <b-form-input class="insertInput"
                                          type="text"
                                          style="height: 35px;"
                                          placeholder="Subid-3"
                                          v-model="selectedSub3">
                            </b-form-input>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                          <v-select :options="sub4Options"
                                    placeholder="Subid-4"
                                    label="text"
                                    :clearable="false"
                                    :searchable="false"
                                    v-model="selectedSub4">
                          </v-select>
                        </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 mb-2">
                            <b-form-input class="insertInput"
                                          type="text"
                                          style="height: 35px;"
                                          placeholder="ID партнёра"
                                          v-model="selectedPartnerId">
                            </b-form-input>
                        </div>
                    </div>
                </b-card>
            </b-collapse>
            <div class="row" v-if="isTableAdded && !isMobile">
                <div class="col-lg-12">
                  <div class="alert alert-info" role="alert">
                    <h5>Правила добавления данных:</h5>
                    <div>Расход можно вносить в соответствии с датой внесения/изменения расхода в данных: <span>{{settings.expense_edit_date | formatDate}}</span>. Если необходимо внести иные данные до этой даты, выставьте в этом поле 0</div>
                    <div>Ставку можно вносить в соответствии с датой внесения/изменения дохода в данных: <span>{{settings.revenue_edit_date | formatDate}}</span>. Если необходимо внести иные данные до этой даты, выставьте в этом поле 0</div>
                  </div>
                </div>
                <div class="col-lg-12 insertTable">
                    <b-table responsive bordered
                             small
                             head-variant="light"
                             class="insertTable"
                             fixed
                             :items="newData"
                             :fields="editingFields"
                             no-local-sorting>
                        <template v-slot:cell(date)="row">
                            <div style="width: 100%; height: 40px; cursor: pointer;"
                                 v-bind:id="'datePopover' + row.index">
                                <span v-if="row.item.date" class="offersTitle"> {{row.item.date | formatDate}}</span>
                            </div>
                            <b-popover custom-class="datePopover"
                                       ref="datePopover"
                                       :delay="{ show: 50, hide: 200 }"
                                       v-bind:target="'datePopover' + row.index" triggers="click blur">
                                <datepicker input-class="form-control"
                                            class="date"
                                            monday-first
                                            :inline="true"
                                            @selected="onDateChange"
                                            v-model="row.item.date"
                                            :language="ru"
                                            placeholder="">
                                </datepicker>
                            </b-popover>
                        </template>
                        <template v-slot:cell(offer_id)="row">
                            <div style="width: 100%; height: 40px; cursor: pointer;"
                                 v-bind:id="'offersPopover' + row.index">
                                <span v-if="row.item.offer_id" class="offersTitle"> ({{row.item.offer_id.id}}) {{row.item.offer_id.title}}</span>
                            </div>
                            <b-popover placement="topright" custom-class="offersPopover"
                                       :delay="{ show: 50, hide: 200 }"
                                       v-bind:target="'offersPopover' + row.index" triggers="click blur">
                                <v-select class="insertInput" :options="options" :filterable="false"
                                          v-model="row.item.offer_id"
                                          @input="onOfferChange(row)"
                                          @search="onSearch">
                                    <template slot="no-options">
                                        Введите символы...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.id }}
                                            {{ option.title }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            ({{ option.id }})
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </b-popover>
                        </template>
                        <template v-slot:cell(application_owner)="row">
                          <b-form-select
                            size="sm"
                            :options="applicationOwnerOptions"
                            v-model="row.item.application_owner"
                            >
                          </b-form-select>
                        </template>
                        <template v-slot:cell(is_test)="row">
                            <b-form-checkbox
                                    v-model="row.item.is_test"
                                    value="1"
                                    unchecked-value="0">
                            </b-form-checkbox>
                        </template>
                        <template v-slot:cell(sub1)="row">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="row.item.sub1">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(partner_id)="row">
                            <b-form-input class="insertInput"
                                          type="number"
                                          v-model="row.item.partner_id">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(sub2)="row">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="row.item.sub2">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(sub3)="row">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="row.item.sub3">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(sub4)="row">
                          <b-form-select
                              size="sm"
                              :options="sub4Options"
                              v-model="row.item.sub4"
                          >
                          </b-form-select>
                        </template>
                        <template v-slot:cell(source_id)="row">
                            <div style="width: 100%; height: 40px; cursor: pointer;"
                                 v-bind:id="'sourcesPopover' + row.index">
                                <span v-if="row.item.source_id" class="offersTitle"> ({{row.item.source_id.id}}) {{row.item.source_id.title}}</span>
                            </div>
                            <b-popover placement="topright" custom-class="offersPopover"
                                       :delay="{ show: 50, hide: 200 }"
                                       v-bind:target="'sourcesPopover' + row.index" triggers="click blur">
                                <v-select class="insertInput" :options="sourcesOptions" :filterable="false"
                                          v-model="row.item.source_id"
                                          @input="onSourceChange(row)"
                                          @search="onSourcesSearch">
                                    <template slot="no-options">
                                        Введите символы...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.id }}
                                            {{ option.title }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </b-popover>
                        </template>
                        <template v-slot:cell(expense)="row">
                            <b-form-input class="insertInput"
                                          type="number"
                                          step="any"
                                          v-model="row.item.expense">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(expense_rate)="row">
                            <b-form-input class="insertInput"
                                          type="number"
                                          step="any"
                                          v-model="row.item.expense_rate">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(discount)="row">
                            <b-form-input class="insertInput"
                                          min="0" max="100"
                                          type="number"
                                          step="any"
                                          v-model="row.item.discount">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(expense_currency)="row">
                            <div style="width: 100%; height: 40px; cursor: pointer;"
                                 v-bind:id="'expenseCurrencyPopover' + row.index">
                            <span v-if="row.item.expense_currency"
                                  class="offersTitle"> {{row.item.expense_currency}}</span>
                            </div>
                            <b-popover placement="topright" custom-class="offersPopover"
                                       :delay="{ show: 50, hide: 200 }"
                                       v-bind:target="'expenseCurrencyPopover' + row.index" triggers="click blur">
                                <v-select :options="currency"
                                          class="insertInput"
                                          v-model="row.item.expense_currency">
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </b-popover>
                        </template>
                        <template v-slot:cell(leads_count)="row">
                            <b-form-input class="insertInput"
                                          type="number"
                                          v-model="row.item.leads_count">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(lead_rate)="row">
                            <b-form-input class="insertInput"
                                          type="number"
                                          step="any"
                                          v-model="row.item.lead_rate">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(lead_currency)="row">
                            <div style="width: 100%; height: 40px; cursor: pointer;"
                                 v-bind:id="'leadCurrencyPopover' + row.index">
                                <span v-if="row.item.lead_currency"
                                      class="offersTitle"> {{row.item.lead_currency}}</span>
                            </div>
                            <b-popover placement="topright" custom-class="offersPopover"
                                       :delay="{ show: 50, hide: 200 }"
                                       v-bind:target="'leadCurrencyPopover' + row.index" triggers="click blur">
                                <v-select :options="currency"
                                          class="insertInput"
                                          v-model="row.item.lead_currency">
                                    <span slot="no-options">Совпадений не найдено.</span>
                                </v-select>
                            </b-popover>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <i class="icon-fa icon-fa-copy" @click.stop="copyRow(row.item)"></i>
                            <i class="icon-fa icon-fa-trash-o" @click.stop="deleteRow(row.item)"></i>
                        </template>
                    </b-table>
                </div>
                <div class="col-lg-12 mb-2" v-if="isTableAdded && !isMobile">
                    <b-button variant="success" class="ml-2" v-on:click="addRow()">Добавить</b-button>
                    <b-button variant="primary" class="ml-2" v-on:click="save()">Сохранить</b-button>
                    <b-button variant="danger" class="ml-2" v-on:click="resetAll()">Отмена</b-button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div v-if="!isMobile">
                        <b-table hover responsive bordered
                                 small
                                 ref="selectableTable"
                                 :items="dataArray"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getData(1, $event)"
                                 selectable
                                 :select-mode="selectMode"
                                 selected-variant="active"
                                 @row-selected="onRowSelected"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(date)="row">
                                <div>{{row.item.date | formatDate}}</div>
                            </template>
                            <template v-slot:cell(is_test)="row">
                                <div v-if="row.item.is_test == '0'">Нет</div>
                                <div v-if="row.item.is_test == '1'">Да</div>
                            </template>
                            <template v-slot:cell(partner_id)="row">
                                <span>{{row.item.partner_id }}</span>
                                <span>({{row.item.offer.affise_platform | formatPlatform }})</span>
                            </template>
                            <template v-slot:cell(offer_id)="row">
                                <span>({{row.item.offer.id }})</span>
                                <span>{{row.item.offer.title }}</span>
                            </template>
                            <template v-slot:cell(application_owner)="row">
                              <span>{{getAppOwnerByValue(row.item.application_owner)}}</span>
                            </template>
                            <template v-slot:cell(source_id)="row">
                                <span>({{row.item.source.id }})</span>
                                <span>{{row.item.source.title }}</span>
                            </template>
                            <template v-slot:cell(expense_with_discount)="row">
                                <span>{{row.item.expense_with_discount }}</span>
                                <span>{{row.item.expense_currency }}</span>
                            </template>
                            <template v-slot:cell(revenue)="row">
                                <span>{{row.item.revenue }}</span>
                                <span>{{row.item.lead_currency }}</span>
                            </template>
                            <template v-slot:cell(lead_rate)="row">
                                <span>{{row.item.lead_rate }}</span>
                                <span>{{row.item.lead_currency }}</span>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <div v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin' || $currentUser.role == 'leader'">
                                    <b-button size="sm" class="btn btn-warning"
                                              v-if="new Date(row.item.date) >= new Date(settings.edit_date) || new Date(row.item.date) >= new Date(settings.expense_edit_date)  || new Date(row.item.date) >= new Date(settings.revenue_edit_date)"
                                              @click.stop="edit(row)">
                                        <i class="icon-fa icon-fa-edit"></i>
                                    </b-button>
                                    <b-button size="sm" class="btn btn-danger"
                                              v-if="new Date(row.item.date) >= new Date(settings.edit_date)"
                                              @click.stop="deleteData(row.item)">
                                        <i class="icon-fa icon-fa-trash-o"></i>
                                    </b-button>
                                </div>
                            </template>
                            <template v-slot:cell(created_at)="row">
                                <div>{{row.item.cdate | formatDate}}</div>
                            </template>
                        </b-table>
                    </div>
                    <div v-if="isMobile">
                        <b-table hover responsive bordered stacked
                                 small
                                 :items="dataArray"
                                 :fields="fields"
                                 no-local-sorting
                                 :sort-by.sync="sortBy"
                                 @sort-changed="getData(1, $event)"
                                 :sort-desc.sync="sortDesc"
                                 :sort-direction="sortDirection">
                            <template v-slot:cell(date)="row">
                                <div>{{row.item.date | formatDate}}</div>
                            </template>
                            <template v-slot:cell(partner_id)="row">
                                <span>{{row.item.partner_id }}</span>
                                <span>({{row.item.offer.affise_platform | formatPlatform }})</span>
                            </template>
                            <template v-slot:cell(offer_id)="row">
                                <span>{{row.item.offer.title }}</span>
                                <span>({{row.item.offer_id }})</span>
                            </template>
                            <template v-slot:cell(source_id)="row">
                                <span>{{row.item.source.title }}</span>
                                <span>({{row.item.source_id }})</span>
                            </template>
                            <template v-slot:cell(application_owner)="row">
                              <span>{{getAppOwnerByValue(row.item.application_owner)}}</span>
                            </template>
                            <template v-slot:cell(expense_with_discount)="row">
                                <span>{{row.item.expense_with_discount }}</span>
                                <span>{{row.item.expense_currency }}</span>
                            </template>
                            <template v-slot:cell(lead_rate)="row">
                                <span>{{row.item.lead_rate }}</span>
                                <span>{{row.item.lead_currency }}</span>
                            </template>
                            <template v-slot:cell(revenue)="row">
                                <span>{{row.item.revenue }}</span>
                                <span>{{row.item.lead_currency }}</span>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <div v-if="row.item.user_id == $currentUser.id || $currentUser.role == 'admin' || $currentUser.role == 'leader'">
                                    <b-button size="sm" class="btn btn-warning"
                                              v-if="new Date(row.item.date) >= new Date(settings.edit_date) || new Date(row.item.date) >= new Date(settings.expense_edit_date)  || new Date(row.item.date) >= new Date(settings.revenue_edit_date)"
                                              @click.stop="edit(row)">
                                        <i class="icon-fa icon-fa-edit"></i>
                                    </b-button>
                                    <b-button size="sm" class="btn btn-danger"
                                              v-if="new Date(row.item.date) >= new Date(settings.edit_date)"
                                              @click.stop="deleteData(row.item)">
                                        <i class="icon-fa icon-fa-trash-o"></i>
                                    </b-button>
                                    <b-button size="sm" class="btn btn-warning"
                                              @click.stop="copyRowInMobile(row)">
                                        <i class="icon-fa icon-fa-copy"></i>
                                    </b-button>
                                </div>
                            </template>
                            <template v-slot:cell(created_at)="row">
                                <div>{{row.item.cdate | formatDate}}</div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5">
                    <div class="" role="status" aria-live="polite">Всего записей: {{ pager.total }}</div>
                </div>
                <div class="col-sm-7">
                    <div class="float-right">
                        <nav aria-label="Page navigation">
                            <ul class="pagination justify-content-center">
                                <b-pagination size="sm" :total-rows="pager.total"
                                              v-model="pager.current_page"
                                              v-on:change="getData($event)"
                                              :per-page="pager.per_page"></b-pagination>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <b-modal id="createData" ref="dataCreateModal" @hidden="hideRowMobileModal" size="md"
                     title="Добавить данные"
                     hide-footer>
                <CreateDataModal :applicationOwnerOptions="applicationOwnerOptions" v-bind:form="rowData"></CreateDataModal>
            </b-modal>

            <b-modal ref="dataEditModal" @hidden="hideModal" id="dataEditModal" size="md"
                     title="Редактировать данные" hide-footer>
                <EditDataModal :applicationOwnerOptions="applicationOwnerOptions" v-bind:form="selectedData"></EditDataModal>
            </b-modal>

            <b-modal id="leadRateEditModal" ref="leadRateEditModal"
                     @hidden="hideModal"
                     size="md" title="Редактировать данные" hide-footer>
              <MassUpdateDataModal   :applicationOwnerOptions="applicationOwnerOptions" :selectedData="selected"></MassUpdateDataModal>
            </b-modal>

            <b-modal id="uploadDataModal" ref="uploadDataModal"
                     @ok="uploadData"
                     @hidden="uploadDataModal.file = null"
                     :ok-disabled="! Boolean(uploadDataModal.file)"
                     ok-title="Загрузить"
                     cancel-title="Отмена"
                     title="Загрузить данные">
              <span class="alert-danger" v-for="error in uploadDataModal.errors">{{ error }}</span>
              <form class="mt-2">
                <b-form-group label="Выберите файл или перенесите сюда">
                  <b-form-file
                    v-model="uploadDataModal.file"
                    :state="Boolean(uploadDataModal.file)"
                    accept=".xlsx, .xls"
                    size="sm"
                    placeholder="Файл не выбран"
                    drop-placeholder="Drop file here..."
                  ></b-form-file>
                </b-form-group>
              </form>
            </b-modal>

        </div>
    </div>
</template>
<script>
    import CreateDataModal from './modals/CreateDataModal.vue'
    import OffersService from '../../services/offersDataService'
    import EditDataModal from './modals/EditDataModal.vue'
    import SourcesService from '../../services/sourcesDataService'
    import DataService from '../../services/dataDataService'
    import Datepicker from 'vuejs-datepicker'
    import moment from 'moment'
    import {ru} from '../../services/customLocaleDatepicker'
    import batchDataService from "../../services/batchDataService";
    import saveFiltersMixin from "./mixins/saveFiltersMixin";
    import DateRangePicker from 'vue2-daterange-picker'
    import MassUpdateDataModal from './modals/MassUpdateDataModal'
    import dataOptionsMixin from "./mixins/dataOptionsMixin";

    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import vue2DateRangePickerMixin from "./mixins/vue2DateRangePickerMixin";
    import SettingsService from "../../services/settingsDataService";

    export default {
        name: 'dataComponent',
        components: {
            CreateDataModal: CreateDataModal,
            EditDataModal: EditDataModal,
            Datepicker: Datepicker,
            DateRangePicker: DateRangePicker,
            MassUpdateDataModal: MassUpdateDataModal
        },
      mixins:[
        saveFiltersMixin,
        vue2DateRangePickerMixin,
        dataOptionsMixin
      ],
        filters: {
            formatDate: function (value) {
                if (value) {
                    return moment(new Date(value)).locale('ru').format('D MMM YYYY')
                }
            },
            formatPlatform: function (value) {
                if (value) {
                    let matches = value.match(/\b(\w)/g);
                    let acronym = matches.join('');

                    return acronym;
                }
            }
        },
        data() {
            return {
                settings: {
                  edit_date: null,
                  revenue_edit_date: null,
                  expense_edit_date: null
                },
                selectOffers: [],
                search: [],
                source: [],
                sources: [],
                isTestOptions: [
                    {value: 0, label: 'Не тест'},
                    {value: 1, label: 'Тест'},
                    {value: null, label: 'Все данные'},
                ],
                isTest: {value: 0, label: 'Не тест'},
                selectedSub1: '',
                selectedSub2: '',
                selectedSub3: '',
                selectedSub4: '',
                selectedPartnerId: '',
                showCollapse2: false,
                leadRate: 0,
                showDismissibleAlert: false,
                alertText: '',
                showSuccessAlert: false,
                successAlertText: '',
                dataArray: [],
                pager: {},
                user: this.$currentUser.role == 'leader' || this.$currentUser.role == 'admin' ? [this.$currentUser] : null,
                moment: moment,
                today: moment(new Date()).format('D-M-Y'),
                users: [],
                type: {
                    label: 'Офферы всех типов',
                    value: null
                },
                types: [
                    {
                        label: 'Белые',
                        value: 'white'
                    },
                    {
                        label: 'Серые',
                        value: 'grey'
                    },
                    {
                        label: 'Офферы всех типов',
                        value: null
                    }
                ],
                secondDateRange: {
                    startDate: null,
                    endDate: null
                },
                captions: {
                    title: 'Выбрать даты создания данных',
                    ok_button: 'Применить'
                },
                secondCaptions: {
                    title: 'Выбрать даты внесения данных',
                    ok_button: 'Применить'
                },
                applicationOwnerOptions: [
                  {text: 'Выберите значение', value: null, disabled: true},
                  {text: 'Наше/Аренда', value: 'own'},
                  {text: 'Клиента/Веб', value: 'client'}
                ],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true
                    },
                    {
                        key: 'date',
                        label: 'Дата',
                        sortable: true
                    },
                    {
                        key: 'offer_id',
                        label: 'Оффер',
                        sortable: true
                    },
                    {
                        key: 'partner_id',
                        label: 'ID партнёра',
                        sortable: true
                    },
                    {
                        key: 'sub1',
                        label: 'Subid-1',
                        sortable: true
                    },
                    {
                        key: 'sub2',
                        label: 'Subid-2',
                        sortable: true
                    },
                    {
                        key: 'sub3',
                        label: 'Subid-3',
                        sortable: true
                    },
                    {
                        key: 'sub4',
                        label: 'Subid-4',
                        sortable: true
                    },
                    {
                        key: 'source_id',
                        label: 'Источник',
                        sortable: true
                    },
                    {
                        key: 'expense_with_discount',
                        label: 'Расход',
                        sortable: true
                    },
                    {
                        key: 'leads_count',
                        label: 'Лиды',
                        sortable: true
                    },
                    {
                        key: 'lead_rate',
                        label: 'Ставка',
                        sortable: true
                    },
                    {
                        key: 'revenue',
                        label: 'Доход',
                        sortable: true
                    },
                    {
                        key: 'profit',
                        label: 'Прибыль,$',
                        sortable: true
                    },
                    {
                        key: 'is_test',
                        label: 'Тест',
                        sortable: true
                    },
                    {
                        key: 'roi',
                        label: 'ROI,%',
                        sortable: true
                    },
                    {
                        key: 'gm_rev',
                        label: 'GM/REV,%',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Дата создания',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: 'Действия',
                        tdAttr: {'align': "center"}
                    }
                ],
                editingFields: [
                    {
                        key: 'date',
                        label: 'Дата',
                        sortable: false,
                        tdClass: 'dateTd'
                    },
                    {
                        key: 'offer_id',
                        label: 'Оффер',
                        sortable: false,
                        thClass: 'widthOffer wordBreak',
                        tdClass: 'offerTd'
                    },
                    {
                        key: 'partner_id',
                        label: 'ID партнера',
                        sortable: false,
                        thClass: 'wordBreak widthPartnerId',
                        tdClass: 'partnerTd'
                    },
                    {
                        key: 'is_test',
                        label: 'Тест',
                        sortable: false,
                        thClass: 'widthIsTest',
                    },
                    {
                        key: 'sub1',
                        label: 'Subid-1',
                        sortable: false,
                    },
                    {
                        key: 'sub2',
                        label: 'Subid-2',
                        sortable: false
                    },
                    {
                        key: 'sub3',
                        label: 'Subid-3',
                        sortable: false,
                    },
                    {
                        key: 'sub4',
                        label: 'Subid-4',
                        sortable: false
                    },
                    {
                        key: 'source_id',
                        label: 'Источник',
                        sortable: false,
                        thClass: 'widthSource',
                        tdClass: 'sourceTd'
                    },
                    {
                      key: 'expense',
                      label: 'Расход',
                      sortable: false,
                      tdClass: 'expenseTd'
                    },
                    {
                        key: 'expense_rate',
                        label: 'Ставка расхода',
                        sortable: false,
                        tdClass: 'expenseTd'
                    },
                    {
                        key: 'expense_currency',
                        label: 'Валюта расхода',
                        sortable: false,
                        thClass: 'wordBreak widthCurrency',
                        tdClass: 'expenseCurrencyTd'
                    },
                    {
                        key: 'leads_count',
                        label: 'Лиды',
                        sortable: false,
                        tdClass: 'leadsCountTd'
                    },
                    {
                        key: 'lead_rate',
                        label: 'Ставка',
                        sortable: false,
                        thClass: 'wordBreak widthLeadRate',
                        tdClass: 'leadsRateTd'
                    },
                    {
                        key: 'lead_currency',
                        label: 'Валюта ставки',
                        sortable: false,
                        thClass: 'wordBreak widthCurrency',
                        tdClass: 'leadsCurrencyTd'
                    },
                    {
                        key: 'discount',
                        label: 'Скидка,%',
                        thClass: 'widthDiscount',
                        sortable: false
                    },
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'actionsClass'
                    }
                ],
                newData: [],
                sortBy: 'created_at',
                sortDesc: true,
                sortDirection: 'desc',
                selectedData: null,
                isMobile: false,
                window: {
                    width: 0,
                    height: 0
                },
                isTableAdded: false,
                currency: [],
                options: [],
                offerIdEdit: false,
                sourcesOptions: [],
                selectMode: 'multi',
                selected: [],
                defaultDate: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)),
                rowData: {
                    date: null,
                    offer_id: '',
                    application_owner: null,
                    sub1: '',
                    sub2: '',
                    sub3: '',
                    sub4: '',
                    source_id: '',
                    expense: '',
                    expense_rate: '',
                    expense_currency: '',
                    leads_count: '',
                    lead_rate: '',
                    lead_currency: '',
                    partner_id: '',
                    discount: 0,
                    is_test: 0,
                    def: this.defaultDate
                },
                pageSize: 50,
                isXl: false,
                ru: ru,
                filterValues: {},
                uploadDataModal: {
                  errors: [],
                  file: null,
                },
                savedFiltersName: 'data',
            }
        },
        methods: {
            getMainSetting() {
              SettingsService.getMainSetting()
                  .then(function (settings) {
                    this.settings = settings
                  }.bind(this))
            },
            onClick() {
                this.showCollapse2 = !this.showCollapse2;
            },
            getData(page, sort) {
                if (this.useSavedFilters == true) {
                    let filters = this.getFilters(this.savedFiltersName)

                    if (filters) {
                        page = filters.page
                        sort = filters.sort

                        this.passFilters(filters)
                    }
                }

                if (!page) {
                    page = 1;
                }

                if (!sort) {
                    sort = this;
                }

                this.setFilters()

                if (this.isMobile) {
                    this.pageSize = 10;
                }

                let filtersObject = this.prepareFiltersObject(page, sort)

                this.saveFilters(this.savedFiltersName, this.stringify(filtersObject))

                DataService.getData(page, sort, this.pageSize, this.filterValues)
                    .then(data => {
                        this.pager = data;
                        this.dataArray = data.data
                        this.useSavedFilters = false
                    })
            },
            selectRange(event) {
                this.range = event;
            },
            selectStartRange(event) {
                this.range.startDate = event;
            },
            selectEndRange(event) {
                this.range.endDate = event;
            },
            selectSecondRange(event) {
                this.secondDateRange = event;
            },
            selectSecondStartRange(event) {
                this.secondDateRange.startDate = event;
            },
            selectSecondEndRange(event) {
                this.secondDateRange.endDate = event;
            },
            getSources() {
                OffersService.getSourcesForSelect()
                    .then(function (response) {
                        this.sources = response
                    }.bind(this))
            },
            prepareFiltersObject(page, sort) {
                let object = {
                    page: page,
                    sort: {sortBy: sort.sortBy, sortDesc: sort.sortDesc},
                    isTest: this.isTest,
                    selectedPartnerId: this.selectedPartnerId,
                    selectedSub1: this.selectedSub1,
                    selectedSub2: this.selectedSub2,
                    selectedSub3: this.selectedSub3,
                    selectedSub4: this.selectedSub4,
                    type: this.type,
                    user: this.user,
                    range: this.range,
                    secondDateRange: this.secondDateRange,
                    source: this.source,
                    search: this.search
                }

                return object;
            },
            passFilters(filters) {
                this.range = this.dateConvert(filters.range.startDate, filters.range.endDate)
                this.secondDateRange = this.dateConvert(filters.secondDateRange.startDate, filters.secondDateRange.endDate)
                this.search = filters.search
                this.user = filters.user
                this.source = filters.source
                this.isTest = filters.isTest
                this.selectedPartnerId = filters.selectedPartnerId
                this.selectedSub1 = filters.selectedSub1
                this.selectedSub2 = filters.selectedSub2
                this.selectedSub3 = filters.selectedSub3
                this.selectedSub4 = filters.selectedSub4
                this.type = filters.type
                this.pageSize = filters.pageSize
            },
            setFilters() {
                let userArray = [];

                if (this.$currentUser.role == 'admin' || this.$currentUser.role == 'leader') {
                    if (this.user && this.user.length != 0) {
                        this.user.forEach(function (userItem) {
                            userArray.push(userItem.id)
                        });
                    } else {
                        userArray.push('all')
                    }
                }

                if (this.$currentUser.role == 'user') {
                    userArray.push(this.$currentUser.id);
                }

                let sourceArray = [];

                if (this.source && this.source.length != 0) {
                    this.source.forEach(function (sourceItem) {
                        sourceArray.push(sourceItem.id)
                    });
                } else {
                    sourceArray.push('all')
                }

                let searchArray = [];

                if (this.search.length > 0) {
                    this.search.forEach(function (searchItem) {
                        searchArray.push(searchItem.id)
                    });
                } else {
                    searchArray = null;
                }

                let range = {
                    startDate: this.range.startDate ? this.convertISODate(this.range.startDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substring(0, 10),
                    endDate: this.range.endDate ? this.convertISODate(this.range.endDate).toISOString().substring(0, 10) : new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substring(0, 10)
                };

                let secondDateRange = {
                    endDate: null,
                    startDate: null
                }
                secondDateRange.endDate = this.secondDateRange.endDate ? this.convertISODate(this.secondDateRange.endDate).toISOString().substring(0, 10) : null;
                secondDateRange.startDate = this.secondDateRange.startDate ? this.convertISODate(this.secondDateRange.startDate).toISOString().substring(0, 10) : null;

                this.filterValues = {
                    userArray: userArray,
                    sourceArray: sourceArray,
                    searchArray: searchArray,
                    range: range,
                    secondDateRange: secondDateRange,
                    isTest: this.isTest.value,
                    selectedPartnerId: this.selectedPartnerId,
                    selectedSub1: this.selectedSub1,
                    selectedSub2: this.selectedSub2,
                    selectedSub3: this.selectedSub3,
                    selectedSub4: this.selectedSub4,
                    type: this.type.value
                }
            },
            getOffersForSelect() {
                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }
                let user = null;

                OffersService.getOffers(1, sort, null, range, user, true)
                    .then(function (response) {
                        this.selectOffers = response;

                    }.bind(this))
            },
            filterOffers(options, search) {
                if (search) {
                    return options.filter(option => {

                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
                            || option.id.toString().indexOf(search.toString()) >= 0
                            || option.affise_id && option.affise_id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
            filterSources(options, search) {
                if (search) {
                    return options.filter(option => {

                        return option.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
                            || option.id.toString().indexOf(search.toString()) >= 0;
                    });
                }
            },
            copySelected() {
                let data = [];

                this.selected.forEach(function (item) {
                    let row = {}
                    row.offer_id = item.offer;
                    row.application_owner = item.application_owner,
                    row.source_id = item.source;
                    row.date = new Date(item.date) >= new Date(this.settings.edit_date) ? item.date : this.settings.edit_date
                    row.sub1 = item.sub1
                    row.sub2 = item.sub2
                    row.sub3 = item.sub3
                    row.sub4 = item.sub4
                    row.expense = item.expense
                    row.expense_currency = item.expense_currency
                    row.leads_count = item.leads_count
                    row.lead_rate = item.lead_rate
                    row.lead_currency = item.lead_currency
                    row.revenue = item.revenue
                    row.expense_usd = item.expense_usd
                    row.revenue_usd = item.revenue_usd
                    row.partner_id = item.partner_id
                    row.discount = item.discount
                    row.expense_with_discount = item.expense_with_discount
                    row.expense_with_discount_usd = item.expense_with_discount_usd
                    row.is_test = item.is_test
                    row.roi = item.roi
                    row.gm_rev = item.gm_rev
                    row.profit = item.profit

                    data.push(row)
                }.bind(this));
                this.newData = this.newData.concat(data)
                this.isTableAdded = true;
            },
            handleOkRateEditModal(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.handleEditLeadRate()
            },
            changeLeadRate() {
                if (this.selected.length == 0) {
                    this.alertText = 'Пожалуйста, выберите данные.'
                    this.showDismissibleAlert = true
                } else {
                    this.$refs.leadRateEditModal.show()
                }
            },
            copyRow(item) {
                this.newData.push({
                    date: new Date(item.date) >= new Date(this.settings.edit_date) ? item.date : this.settings.edit_date,
                    offer_id: item.offer_id,
                    application_owner: item.application_owner,
                    partner_id: item.partner_id,
                    sub1: item.sub1,
                    sub2: item.sub2,
                    sub3: item.sub3,
                    sub4: item.sub4,
                    source_id: item.source_id,
                    expense: item.expense,
                    expense_rate: item.expense_rate,
                    expense_currency: item.expense_currency,
                    leads_count: item.leads_count,
                    lead_rate: item.lead_rate,
                    lead_currency: item.lead_currency,
                    discount: item.discount,
                    is_test: item.is_test
                })
            },
            copyRowInMobile(row) {
                this.rowData = {
                    date: new Date(row.item.date) >= new Date(this.settings.edit_date) ? row.item.date : this.settings.edit_date,
                    offer_id: row.item.offer,
                    application_owner: row.application_owner,
                    partner_id: row.item.partner_id,
                    sub1: row.item.sub1,
                    sub2: row.item.sub2,
                    sub3: row.item.sub3,
                    sub4: row.item.sub4,
                    source_id: row.item.source,
                    expense: row.item.expense,
                    expense_rate: row.item.expense_rate,
                    expense_currency: row.item.expense_currency,
                    leads_count: row.item.leads_count,
                    lead_rate: row.item.lead_rate,
                    lead_currency: row.item.lead_currency,
                    discount: row.item.discount,
                    is_test: row.item.is_test
                };
                this.$refs.dataCreateModal.show()
            },
            hideRowMobileModal() {
                this.rowData = {
                    date: this.defaultDate >= new Date(this.settings.edit_date) ? this.defaultDate : this.settings.edit_date,
                    offer_id: '',
                    application_owner: null,
                    sub1: '',
                    sub2: '',
                    sub3: '',
                    sub4: '',
                    source_id: '',
                    expense: '',
                    expense_rate: '',
                    expense_currency: '',
                    leads_count: '',
                    lead_rate: '',
                    lead_currency: '',
                    partner_id: '',
                    discount: 0,
                    is_test: 0
                };
                this.$refs.dataCreateModal.hide()
            },
            resetFilters() {
                this.sortBy = 'updated_at';
                this.sortDesc = true;
                this.sortDirection = 'desc';
                this.user = this.$currentUser.role == 'leader' || this.$currentUser.role == 'admin' ? [this.$currentUser] : null;
                this.range = {
                    startDate: null,
                    endDate: null
                };
                this.secondDateRange = {
                    startDate: null,
                    endDate: null
                };

                this.search = []
                this.source = []
                this.isTest = {value: 0, label: 'Не тест'}
                this.selectedSub1 = ''
                this.selectedSub2 = ''
                this.selectedSub3 = ''
                this.selectedSub4 = ''
                this.selectedPartnerId = ''
                this.type = {
                    label: 'Все',
                    value: null
                };

                //re-initialize element
                this.dateRange++;

                this.getData();
            },
            getUsers() {
                OffersService.getUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            getLeaderUsers() {
                OffersService.getLeaderUsers()
                    .then(users => {
                        this.users = users
                    })
            },
            edit(item) {
                this.selectedData = item
                this.$refs.dataEditModal.show()
            },
            deleteData(data) {
              this.$bvModal.msgBoxConfirm('ID: ' + data.id, {
                title: 'Вы точно уверены, что хотите удалить?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ДА',
                cancelTitle: 'НЕТ',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
              })
                .then(value => {
                  if(value !== true) {
                    return
                  }

                  if(! confirm('Точно удаляем?')) {
                    return;
                  }

                  DataService.deleteData(data.id)
                    .then(response => {
                      if (response.success) {
                        this.getData();

                        toastr.success('Данные удалены!')
                      }
                    })
                })
                .catch(err => {
                })

            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;

                this.isMobile = this.window.width < 415;
                this.isXl = this.window.width > 1199;
            },
            addTable() {
              this.getMainSetting();
              if (!this.isTableAdded) {
                  let n = new Date();

                  this.newData.push({
                      date: this.defaultDate >= new Date(this.settings.edit_date) ? this.defaultDate : this.settings.edit_date,
                      offer_id: '',
                      application_owner: null,
                      partner_id: '',
                      sub1: '',
                      sub2: '',
                      sub3: '',
                      sub4: '',
                      source_id: '',
                      expense: '',
                      expense_rate: '',
                      expense_currency: '',
                      leads_count: '',
                      lead_rate: '',
                      lead_currency: '',
                      discount: 0,
                      is_test: 0
                  })
              }
              this.onSearch(' ')
              this.onSourcesSearch(' ')

              this.isTableAdded = true;
            },
            addRow() {
                let n = new Date();

                this.newData.push({
                    date: this.defaultDate >= new Date(this.settings.edit_date) ? this.defaultDate : this.settings.edit_date,
                    offer_id: '',
                    application_owner: null,
                    partner_id: '',
                    sub1: '',
                    sub2: '',
                    sub3: '',
                    sub4: '',
                    source_id: '',
                    expense: '',
                    expense_rate: '',
                    expense_currency: '',
                    leads_count: '',
                    lead_rate: '',
                    lead_currency: '',
                    discount: 0,
                    is_test: 0
                })
            },
            deleteRow(row) {
                let index = this.newData.indexOf(row)
                this.newData.splice(index, 1)
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            resetAll() {
                this.newData = [];
                this.isTableAdded = false;
            },
            onSearch(search, loading) {
                if (!search) {

                    return;
                }
                if (loading) {
                    loading(true);
                }
                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }

                let user = null;

                OffersService.getDataSelectOffers(1, sort, search, range, user, true)
                    .then(function (response) {
                        let options = [];
                        response.forEach(function (element) {
                            element.label = '';
                            options.push(element)
                        });
                        this.options = options;
                        if (loading) {
                            loading(false);
                        }
                    }.bind(this), 350)
            },
            onSourcesSearch(search, loading) {
                if (!search) {

                    return;
                }
                if (loading) {
                    loading(true);
                }

                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    startDate: null,
                    endDate: null
                }
                let user = null;

                SourcesService.getSources(1, sort, search, range, user, null, true)
                    .then(function (response) {
                        let options = [];
                        response.forEach(function (element) {
                            element.label = '';
                            options.push(element)
                        });
                        this.sourcesOptions = options;
                        if (loading) {
                            loading(false);
                        }
                    }.bind(this), 350)
            },
            save() {
                //validate
                let rows = document.getElementsByTagName('tbody')[0].children;

                for (var index in this.newData) {
                    if (!this.newData[index].date) {
                        let cell = rows[index].getElementsByClassName('dateTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите дату!')

                        return;
                    }
                    if (!this.newData[index].offer_id) {
                        let cell = rows[index].getElementsByClassName('offerTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите оффер!')

                        return;
                    }
                    if (this.$currentUser.department === 'adkey' && !this.newData[index].application_owner) {
                      let cell = rows[index].getElementsByClassName('applicationOwner');
                      cell[0].style.borderColor = '#f35a3d';

                      toastr.error('Введите владельца приложения!')

                      return;
                    }
                    if (!this.newData[index].partner_id) {
                        let cell = rows[index].getElementsByClassName('partnerTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите ID партнёра!')

                        return;
                    }
                    if (!this.newData[index].source_id) {
                        let cell = rows[index].getElementsByClassName('sourceTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите источник!')

                        return;
                    }
                    if (!this.newData[index].expense && !this.newData[index].expense_rate) {
                        let cell = rows[index].getElementsByClassName('expenseTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите расход или ставку расхода!')

                        return;
                    }

                    if (this.newData[index].expense && this.newData[index].expense_rate) {
                        let cell = rows[index].getElementsByClassName('expenseTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите или расход, или ставку расхода!')

                        return;
                    }

                    if (!this.newData[index].expense_currency) {
                        let cell = rows[index].getElementsByClassName('expenseCurrencyTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите валюту расхода!')

                        return;
                    }

                    if (!this.newData[index].leads_count) {
                        let cell = rows[index].getElementsByClassName('leadsCountTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите количество лидов!')

                        return;
                    }
                    if (!this.newData[index].lead_rate) {
                        let cell = rows[index].getElementsByClassName('leadsRateTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите ставку!')

                        return;
                    }
                    if (!this.newData[index].lead_currency) {
                        let cell = rows[index].getElementsByClassName('leadsCurrencyTd');
                        cell[0].style.borderColor = '#f35a3d';

                        toastr.error('Введите валюту ставки!')

                        return;
                    }
                }

                DataService.save(this.newData)
                    .then(function (response) {
                        if (response.success) {
                            this.resetAll();
                            this.getData();

                            toastr.success('Данные внесены!')
                        }
                      if (response.error) {
                        toastr.error('Проверьте внесенные значения ставки и расхода в соответствии с разрешенными датами внесения/изменения дохода и расхода.')
                      }
                    }.bind(this))
            },
            hideModal() {
                this.$refs.dataEditModal.hide()
                this.getData();
            },
            onRowSelected(items) {
                this.selected = items
            },
            selectAllRows() {
                this.$refs.selectableTable.selectAllRows()
            },
            unselectAllRows() {
                this.$refs.selectableTable.clearSelected()
            },
            onOfferChange(row) {
                let platform = this.newData[row.index].offer_id ? this.newData[row.index].offer_id.affise_platform : null;
                this.newData[row.index].lead_currency = this.newData[row.index].offer_id ? this.newData[row.index].offer_id.currency : this.newData[row.index].lead_currency

                if (platform && platform == 'Zorka Market') {
                    this.newData[row.index].partner_id = this.$currentUser.market_partner_id
                } else {
                    this.newData[row.index].partner_id = this.$currentUser.network_partner_id
                }
            },
            onSourceChange(row) {
                this.newData[row.index].expense_currency = this.newData[row.index].source_id ? this.newData[row.index].source_id.currency : this.newData[row.index].expense_currency
            },
            onDateChange() {
                this.$refs.datePopover.$emit('close')
            },
            addNewColumnForAdkeyUser(){
                let td = {
                  key: 'application_owner',
                  label: 'Приложение',
                  sortable: true,
                }
                this.fields.splice(3, 0, td)


                let tdForEdit = Object.assign({}, td)
                tdForEdit.sortable = false
                tdForEdit.tdClass = 'applicationOwner'
                this.editingFields.splice(2, 0 , tdForEdit)
            },
            getAppOwnerByValue(value) {
              let appOwner =  this.applicationOwnerOptions.find((option)=> option.value === value)
              if(!appOwner.value){
                return  '';
              }
              return appOwner.text
            },

            openDataUploadModal() {
              this.uploadDataModal.errors = []
              this.uploadDataModal.file = null
              this.showSuccessAlert = false
              this.successAlertText = ''
              this.$refs.uploadDataModal.show()
            },

            async uploadData(event) {
              event.preventDefault()
              this.uploadDataModal.errors = []
              if(this.uploadDataModal.file === null) {
                this.uploadDataModal.errors.push('Выберите файл')

                return
               }

              let formData = new FormData()
              formData.append('report', this.uploadDataModal.file)

              let response = await batchDataService.saveDataBatch(formData)
              if(response.status === true) {
                this.showSuccessAlert = true
                this.successAlertText = 'Файл успешно загружен. Результат загрузки вы получите на почту'
                this.$refs.uploadDataModal.hide()

                return
              }

              this.uploadDataModal.errors = response.errors
            },

        },
        beforeMount() {
            this.getMainSetting();

            this.useSavedFilters = true;
            this.rowData.date = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)) >= new Date(this.settings.edit_date) ? new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)) : this.settings.edit_date;


            this.getSources();
            this.getOffersForSelect();


            if (this.$currentUser.role == 'leader') {
                this.getLeaderUsers()
            } else if (this.$currentUser.role == 'admin') {
                this.getUsers()
            }

            this.getCurrency()

        },
        mounted() {
          this.getData()
        },
      created() {
            window.addEventListener('resize', this.handleResize)
            this.handleResize();

            if(this.$currentUser.department === 'adkey') {
              this.addNewColumnForAdkeyUser()
            }
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        watch: {
            'newData': {
                handler: function (newVal, oldVal) {
                    //get new array for affise_id selects
                    this.onSearch(' ')
                    this.onSourcesSearch(' ')
                },
                deep: true
            }
        },
    }
</script>
<style>
    .custom-file-input:lang(en) ~ .custom-file-label::after {
      content: 'Обзор';
    }

    .dateFrom {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-color: #4fc47f;

    }

    .dateTo {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
        border-color: #4fc47f;

    }

    .dateFromCreated {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-color: #007dcc;
    }

    .dateToCreated {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
        border-color: #007dcc;
    }


    .dateLeft {
        width: 100% !important;
    }

    .dateRight {
        width: 100% !important;
    }

    .insertTable input.insertInput {
        border: none !important;
        border-radius: 0 !important;
        padding: 0 !important;
        max-height: 25px;
    }

    .insertTable th {
        width: 60px;
    }

    .insertTable .vs__dropdown-toggle {
        padding: 0;
        border-radius: 0;
        max-height: 30px;
    }

    .insertTable .minWidth {
        min-width: 130px;
        word-wrap: break-word;
    }

    .insertTable .widthOffer {
        width: 150px;
    }

    .insertTable .widthSource {
        width: 150px;
    }

    .insertTable .widthIsTest {
        width: 45px;
    }

    .insertTable .widthCurrency {
        width: 65px;
    }

    .insertTable .actionsClass {
        width: 25px;
    }

    .insertTable .widthLeadRate {
        width: 60px;
    }

    .insertTable .widthPartnerId {
        width: 75px;
    }

    .insertTable .widthDiscount {
        width: 65px;
    }

    .insertTable .vdp-datepicker input {
        border: none !important;
        border-radius: 0 !important;
        padding: 0 !important;
        background-color: white !important;
    }

    .insertTable .offerTd div.selected {
        max-width: 130px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .insertTable .offerTd {
        max-width: 130px;
        max-height: 40px;
        /*white-space: nowrap;*/
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .insertTable .sourceTd {
        max-width: 130px;
        max-height: 40px;
        /*white-space: nowrap;*/
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .insertTable .dateTd {
        max-width: 130px;
        max-height: 40px;
        /*white-space: nowrap;*/
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .insertTable .sourceTd div.selected {
        max-width: 130px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .insertTable .wordBreak {
        white-space: normal !important;
        word-break: break-word !important;
    }

    .insertTable th {
        font-size: 10px;
    }

    .btn i {
        text-align: center !important;
    }

    .offersPopover .selected {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 160px;
        max-height: 40px;
    }

    .offersPopover .arrow {
        display: none !important;
    }

    .offersPopover .popover-body {
        /*padding: 0 !important;*/
        width: 100% !important;
        min-width: 220px !important;
        max-height: 40px;
    }

    .datePopover .popover-body {
        width: 100% !important;
        min-width: 220px !important;
        height: 100%;
    }

    .datePopover {
        max-width: 356px;
    }

    .insertInput .vs__dropdown-toggle {
        border: none;
    }

    .insertInput .vs__selected {
        margin: 0;
    }

    .mainButton {
        width: 100%;
    }

    .filterComponent {
        height: 30px !important;
    }

    .filterComponent .vs__dropdown-toggle {
        height: 30px !important;
    }

    .filterComponent .input-date {
        height: 30px !important;
    }

    .filterComponent .dateFrom {
        height: 30px !important;
    }

    .filterComponent .dateTo {
        height: 30px !important;
    }

    .filterComponent .dateFromCreated {
        height: 30px !important;
    }

    .filterComponent .dateToCreated {
        height: 30px !important;
    }

    .offersPopover .insertInput {
        width: 100% !important;
        min-width: 220px !important;
        max-height: 40px;
    }

    .table-sm th {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
        padding-left: 5px;
        width: .2em;
    }

    .datePickerXl {
        min-width: 100% !important;
        max-width: 100% !important;
    }

    .input-group-append {
        width: 100%;
    }

    .input-date {
        border-top-left-radius: 0.2rem !important;
        border-bottom-left-radius: 0.2rem !important;
    }

    .vdp-datepicker input {
        background-color: white !important;
        width: 100% !important;
    }

    .table th, .table td {
        vertical-align: top;
    }

    .reportrange-text {
        font-size: 0.9rem;
        min-width: 190px;
        height: 30px !important;
        width: 110%!important;
    }

    .slot {
        padding: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    @media (max-width: 576px) {
        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }
    }

    @media (min-width: 768px) {
        .dateLeft .vdp-datepicker__calendar {
            right: 0 !important;
        }

        .dateRight .vdp-datepicker__calendar {
            right: 0 !important;
        }

    }

    /*@media (max-width: 768px) and (min-width: 576px) {*/
    /*.buttonsGroup {*/
    /*margin-right: 40px;*/
    /*}*/
    /*}*/

    /*@media (min-width: 992px) {*/
    /*.buttonsGroup {*/
    /*margin-right: 55px;*/
    /*}*/
    /*}*/

    /*@media (min-width: 1100px) {*/
    /*.buttonsGroup {*/
    /*margin-right: 50px;*/
    /*}*/
    /*}*/

    @media (min-width: 1200px) {
        .input-date {
            width: 146px !important;
        }
    }

    @media (min-width: 1300px) {
        .input-date {
            width: 160px !important;
        }

        /*.buttonsGroup {*/
        /*margin-right: 25px;*/
        /*}*/
    }

    @media (min-width: 1400px) {
        .input-date {
            width: 170px !important;
        }
    }

    @media (min-width: 1500px) {
        .input-date {
            width: 190px !important;
        }
    }

    @media (min-width: 1600px) {
        .input-date {
            width: 200px !important;
        }
    }

    @media (min-width: 1700px) {
        .input-date {
            width: 220px !important;
        }
    }

    @media (min-width: 1800px) {
        .input-date {
            width: 230px !important;
        }
    }

    @media (min-width: 1900px) {
        .input-date {
            width: 240px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/Data.vue